
import L from 'leaflet'
import { map, layerGroup } from './mapManager'
import RectanglePopup from '../components/main/RectanglePopup.vue'
import formatter from './geoUtil'
import { returnVueComponentElement } from './vueUtil'

//线段点的样式
const measureCircleStyle = {
    radius: 4,
    weight: 2,
    stroke: true,
    color: 'red',
    fill: true,
    fillOpacity: 1,
    fillColor: '#ff7800'
}

//画矩形的相关参数
let markerIcon = L.divIcon({
    html: '具体内容', //marker标注
    iconSize: [200, 35], //marker宽高
    iconAnchor: [100, 20], //文字标注相对位置
    className: 'rectangle-label'
})
let labelMarker = null
let myRectangle
let rectangle
let tmpRectangle

let leftTop
let rightBottom
let tipsEl

const op = {
    color: '#0066cc', weight: 3, stroke: true, opacity: 1, dashArray: [10, 10]
}

var callback


var clickEvent = function (e) {
    addPoint(e.latlng)
}

var mouseMoveEvent = function (e) {
    onMove(e)
}
function start(fnc) {
    callback = fnc
    tipsEl = L.DomUtil.create('div', 'widget tips', L.DomUtil.get('map'))
    tipsEl.innerHTML = '<span>点击选取第一个点<span>'
    //设置地图的鼠标按下事件
    map.on("click", clickEvent)
    map.on("mousemove", mouseMoveEvent)
}

function addPoint(latlng) {
    if (!myRectangle) {
        myRectangle = L.layerGroup().addTo(layerGroup)
    }
    myRectangle.addLayer(L.circleMarker(latlng, measureCircleStyle))
    if (leftTop) {
        rightBottom = latlng
        //要删除虚线
        op.dashArray = null
        rectangle = L.rectangle([leftTop, rightBottom], op)
        myRectangle.addLayer(rectangle)
        callback({ leftTop, rightBottom, info: getInfo(rectangle) })
        finish()
        return
    }
    leftTop = latlng
}

function onMove(e) {
    L.DomUtil.setPosition(tipsEl, e.containerPoint)
    if (leftTop) {
        tipsEl.innerHTML = '点击选取第二个点'
        rightBottom = e.latlng
        if (tmpRectangle) {
            tmpRectangle.remove()
        }
        op.dashArray = [10, 10]
        tmpRectangle = L.rectangle([leftTop, rightBottom], op)
        tmpRectangle.addTo(layerGroup)
        markerIcon.options.html = getInfo(tmpRectangle)
        if (labelMarker) {
            labelMarker.setLatLng(tmpRectangle.getCenter())
            labelMarker.setIcon(markerIcon)
        } else {
            labelMarker = L.marker(tmpRectangle.getCenter(), { icon: markerIcon });
            myRectangle.addLayer(labelMarker)
        }
    }
}
function getInfo(rec) {
    let ds = formatter.getWidthAndHigh(rec)
    let area = formatter.formatArea(rec)
    let info = `长宽：${formatter.formatLength(ds[0])}*${formatter.formatLength(ds[1])}<br>面积：${area}`
    return info
}
function finish() {
    let params = { info: getInfo(rectangle), myRectangle }
    //更新
    let con = returnVueComponentElement(RectanglePopup, 'PolygonInfo', { params })
    let popup = L.popup().setContent(con)
    rectangle.bindPopup(popup)
    tipsEl.innerHTML = '点击选取第一个点'

    if (tmpRectangle) {
        tmpRectangle.remove()
    }
    myRectangle = null
    leftTop = null
    rightBottom = null
    labelMarker = null
}

function end() {
    if (tipsEl) {
        L.DomUtil.remove(tipsEl)
    }
    map.off("click",clickEvent)
    map.off("mousemove",mouseMoveEvent)
}
export default {
    start,
    end
}


// WEBPACK FOOTER //
// ./src/util/plotRectangle.js